import { Button } from "best-common-react";
import React, { useRef, useState } from "react";
import useCyberSource from "../../util/CreditCardUtil";
import CreditCardForm from "./CreditCardForm";
import { exchangeTransientToken } from "../../api/CyberSourceApi";
import { BillingDTO } from "../../types/UserBilling";

type NewCreditCardFormProps = {
  show: boolean;
  onClose: () => void;
  userId: number | string;
  refresh: (value: BillingDTO) => Promise<any>;
};

const NewCreditCardForm = ({ show, onClose, userId, refresh }: NewCreditCardFormProps) => {
  const { creditCard, setCreditCard, onSaveFromPermanentToken, onCancel } = useCyberSource(null, Number(userId));
  const [valid, setValid] = useState<boolean>(false);
  const createTokenRef = useRef<
    null | (() => Promise<{ transientToken: string; ccLast4?: string; ccType?: string; ccExp?: string }>)
  >(null);

  const close = () => {
    onCancel();
    onClose();
  };

  const save = async () => {
    if (!createTokenRef.current) return;
    const tokenPayload: any = await createTokenRef.current();
    const exchangeResp = await exchangeTransientToken({
      transientToken: tokenPayload.transientToken,
      ccLast4: tokenPayload.ccLast4,
      ccType: tokenPayload.ccType,
      ccExp: tokenPayload.ccExp,
      firstName: creditCard.firstName,
      lastName: creditCard.lastName,
      addressLine1: creditCard.addressLine1,
      addressLine2: creditCard.addressLine2,
      city: creditCard.city,
      state: creditCard.state,
      zip: creditCard.zip,
      countryCode: tokenPayload.countryCode,
      email: tokenPayload.email,
      phone: creditCard.phone,
    });
    const newUserBillingDto: BillingDTO = await onSaveFromPermanentToken({
      customerId: exchangeResp.customerId,
      paymentInstrumentId: exchangeResp.paymentInstrumentId,
      instrumentIdentifierId: exchangeResp.instrumentIdentifierId,
      ccLast4: exchangeResp.ccLast4,
      ccType: exchangeResp.ccType,
      ccExp: exchangeResp.ccExp,
    });
    refresh(newUserBillingDto);
    close();
  };

  return (
    <>
      {!!show && (
        <div className="bcr-mb-3">
          <CreditCardForm
            cc={creditCard}
            setCC={setCreditCard}
            registerCreateToken={(fn) => {
              createTokenRef.current = fn;
            }}
            setValid={setValid}
          />
          <div className="bcr-mt-3 container" style={{ margin: 0 }}>
            <div className="d-flex justify-content-end">
              <Button variant="primary" className="bcr-me-2" onClick={save} disabled={!valid}>
                Save
              </Button>
              <Button variant="default" onClick={close}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewCreditCardForm;
